import { render, staticRenderFns } from "./CalServer.vue?vue&type=template&id=0fa704bb"
import script from "./CalServer.vue?vue&type=script&lang=js"
export * from "./CalServer.vue?vue&type=script&lang=js"
import style0 from "./CalServer.vue?vue&type=style&index=0&id=0fa704bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports